export function setupUiContainer(scene) {
    const UiContainerViewString = `
   


  <div class="logo is-hidden" id="logo">
    <img src="./Bonfiglioli-logo.png" class="logo" alt="logo">
  </div>
  
  
  <div id="nextPin" class="pinBTN is-hidden">Next Row</div>
  <div id="nextPin2" class="pinBTNMid is-hidden">Next Pin</div>
  <!-- <div id="btn" class="btn is-hidden" >INSTALATION</div> -->
  
  <div id="pinMenu" class="pinMenu is-hidden">
    <div class="rowButtonsDiv">
      <span class="rowButton" data-row="1">Row 1</span>
      <span class="rowButton" data-row="2">Row 2</span>
      <span class="rowButton" data-row="3">Row 3</span>
    </div>

    <div class="pinList" id="row1"></div>
    <div class="pinList" id="row2"></div>
    <div class="pinList" id="row3"></div>
  </div>
  <div id="menuContainerSmall" class="pinMenu is-hidden">
    <div id="pinListSmall" class="pinList2"></div>
  </div>
  <div class="tableDiv is-hidden" id="tableDiv">

    <h3>Test the inverter status LEDs</h3>

    <div class="led-group" data-label="48V">
      <div class="label-container">
        <strong>48V:</strong>
        <div class="tooltip" id="tooltip-48V">Select a status</div>
      </div>

      <div class="radio-group">
        <label><input type="radio" name="led-1" value="orange" data-tooltip="On"><span
            class="color-indicator orange"></span></label>
        <label><input type="radio" name="led-1" value="green" data-tooltip="On, bridge close"><span
            class="color-indicator green"></span></label>
        <label><input type="radio" name="led-1" value="red" data-tooltip="On, bridge open"><span
            class="color-indicator red"></span></label>
        <label><input type="radio" name="led-1" value="off" data-tooltip="No power supply"><span
            class="color-indicator off"></span></label>
      </div>
    </div>

    <div class="led-group" data-label="24V">
      <div class="label-container">
        <strong>24V:</strong>
        <div class="tooltip" id="tooltip-24V">Select a status</div>
      </div>
      <div class="radio-group">
        <label><input type="radio" name="led-2" value="green" data-tooltip="ON"><span
            class="color-indicator green"></span></label>
        <label><input type="radio" name="led-2" value="red" data-tooltip="Active"><span
            class="color-indicator red"></span></label>
        <label><input type="radio" name="led-2" value="off" data-tooltip="No power supply"><span
            class="color-indicator off"></span></label>
      </div>
    </div>

    <div class="led-group" data-label="STO, SBC">
      <div class="label-container">
        <strong>STO, SBC:</strong>
        <div class="tooltip" id="tooltip-STO">Select a status</div>
      </div>
      <div class="radio-group">
        <label><input type="radio" name="led-3" value="green" data-tooltip="OK"><span
            class="color-indicator green"></span></label>
        <label><input type="radio" name="led-3" value="red" data-tooltip="Active"><span
            class="color-indicator red"></span></label>
      </div>
    </div>

    <div class="led-group" data-label="CAN">
      <div class="label-container">
        <strong>CAN:</strong>
        <div class="tooltip" id="tooltip-CAN">Select a status</div>
      </div>
      <div class="radio-group">
        <label><input type="radio" name="led-4" value="green" data-tooltip="Active"><span
            class="color-indicator green"></span></label>
        <label><input type="radio" name="led-4" value="red" data-tooltip="Error"><span
            class="color-indicator red"></span></label>
      </div>
    </div>
  </div>
  <div id="AC" class="annotation is-hidden" >
    <h3>Motor Phases Connections (U, V, W)</h3>
    <p>The inverter clearly indicates the motor phase connections: <b>U, V, and W</b>.<br>
      Use M6 screws tightened to a torque between <b>14 Nm and 16 Nm</b>.<br>
      Ensure all contact surfaces are clean before installation to maintain proper functionality.</p>
  </div>

  <div id="BatteryConn" class="annotation is-hidden" >
    <h3>DC 48V Battery Vehicle Connections</h3>
    <p>The HV battery connections require M6 screws with a torque between <b>14 Nm and 16 Nm</b>.<br>
      Before installation, ensure all contact surfaces are clean and free from oil or dust.<br>
      This guarantees reliable and safe connections for the inverter.</p>
  </div>
  <div id="Mounting" class="annotation is-hidden installMode">
    <h3>Controller Mounting</h3>
    <p>The controller should be mounted to a <b>6 mm thick</b> vertical steel or aluminum plate with <b>6 km/h (1.7
        m/s)</b> airflow perpendicular to the plate, operating at <b>25°C</b>.</p>
    <span class="arrow" id="mount">&#x21E8;</span>
  </div>
  
  <div id="Cleaning" class="annotation is-hidden installMode">
    <h3>Surface Cleaning</h3>
    <p>It's necessary to <b>clean</b> and <b>degrease</b> all installation surfaces before mounting.</p>
    <span class="arrow" id="clean">&#x21E8;</span>
  </div>
  
  <div id="ThermalPaste" class="annotation is-hidden installMode">
    <h3>Thermal Paste Application</h3>
    <p>To guarantee <b>correct surface contact</b>, use a <b>thermal paste</b> to ensure the best possible dissipation
      performance.</p>
    <span class="arrow" id="thermal">&#x21E8;</span>
  </div>
  
  <div id="Screws" class="annotation is-hidden installMode">
    <h3>Screws</h3>
    <p>Use <b>TCEI M4 screws</b> with a torque of <b>4 Nm</b>.</p>
    <span class="arrow" id="screw">&#x21E8;</span>
  </div>
  <div class="backButton is-hidden" id="backButton"><img src="./icon_back.png" class="backBtnImg" /></div>
  
  <div class="indicators is-hidden" id="indicators">

    <span class="indicator" id="batteryConn">Battery</span>
    <span class="indicator" id="vehicleCon">E-Motor</span>
    <span class="indicator" id="espansionConn">Expansion</span>
    <span class="indicator" id="ace">Phases</span>
    <span class="indicator" id="leds">Leds</span>
    <span id="installationBTN" class="indicator installation is-hidden">INSTALLATION</span>


  </div>


   
    `;
    const UiContainerView = document.createElement("div");
    UiContainerView.classList.add("UIContainer");
    UiContainerView.innerHTML = UiContainerViewString;
    document.body.appendChild(UiContainerView);
}
